import { MicroTaskConfig } from '../micro-task/micro-task-config';
import { FlowConfig } from './flow-config';

export class FlowSavePayload {
	//The "newFlow" in this payload will not have been re-versioned yet, it is the responsibility of the consumer of this payload to do that before saving to the DB.
	newFlow: FlowConfig;
	tasks: MicroTaskConfig[];
	selectedTaskID?: string;

	constructor(newFlow: FlowConfig, microTasks: MicroTaskConfig[]) {
		this.newFlow = newFlow;
		this.tasks = microTasks;
	}
}
